import React, {useState} from 'react';
import AddressModal from "../../AddressModal/AddressModal";
import {Link} from "react-router-dom";
import {Accordion} from "react-bootstrap";

const App3 = () => {

    const [showAddressModal, setShowAddressModal] = useState(false);

    const handleShowAddressModal = () => setShowAddressModal(true);
    const handleCloseAddressModal = () => setShowAddressModal(false);

    return (
        <div className="DocumentLinksPage__content-container">
            <h2>Вступительные испытания</h2>
            <p>Все вступительные испытания проводятся на <b>русском языке</b>.
                Проведение вступительного испытания на иностранном языке
                (за исключением вступительного испытания по иностранному языку) и на языке субъектов
                Российской Федерации при поступлении в ГГУ не предусмотрено.</p>
            <p>
                <h6>Университет проводит вступительные испытания:</h6>
                <ul>
                    <li>очно или с использованием дистанционных технологий.
                    </li>
                </ul>
                <h6>Минимальные баллы по общеобразовательным дисциплинам:</h6>
                <ul>
                    <li>экономика – 3 балла;</li>
                    <li>педагогика – 3 балла;</li>
                    <li>история искусств – 3 балла;</li>
                    <li>философия – 3 балла;</li>
                    <li>иностранный язык – 3 балла;</li>
                </ul>
            </p>

            <p>
                <h3>Вступительные испытания проводятся:</h3>
                <ul>
                    <li>Для поступающих с 24 сентября по 22 октября {new Date().getFullYear()} г.</li>
                </ul>
            </p>

            <p>
                <b>Место проведения вступительных испытаний:</b> Московская область, Раменский городской округ, пос.
                Электроизолятор, д. 67
                (<Link to="#" onClick={(e) => {
                e.preventDefault();
                handleShowAddressModal();
            }}>
                как добраться
            </Link>)
            </p>
            <AddressModal show={showAddressModal} onHide={handleCloseAddressModal} showRepresentation={false}/>
            <p>
                На экзамене при себе необходимо иметь паспорт для идентификации Вашей личности, а
                также шариковую ручку.
            </p>

            <p>
                <a
                    href="https://www.art-gzhel.ru/abitur/aspirant/doc/asp_2025.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Расписание вступительных испытаний
                </a>
            </p>

            <p>
                <h5>Программы вступительных испытаний, проводимых организацией самостоятельно:</h5>
                <Accordion>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header>Программы вступительных испытаний</Accordion.Header>
                        <Accordion.Body>
                            <p>Региональная и отраслевая экономика:</p>
                            <ul>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/aspirant/doc/VI_EK_fil.pdf"
                                       target="_blank"
                                       rel="noopener noreferrer">
                                        Философия
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/aspirant/doc/VI_EK_in.pdf"
                                       target="_blank"
                                       rel="noopener noreferrer">
                                        Иностранный язык
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/aspirant/doc/VI_EK_ek.pdf"
                                       target="_blank"
                                       rel="noopener noreferrer">
                                        Экономика
                                    </a>
                                </li>
                            </ul>

                            <p>Методология и технология профессионального образования:</p>
                            <ul>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/aspirant/doc/VI_PED_fil.pdf"
                                       target="_blank"
                                       rel="noopener noreferrer">
                                        Философия
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/aspirant/doc/VI_PED_in.pdf"
                                       target="_blank"
                                       rel="noopener noreferrer">
                                        Иностранный язык
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/aspirant/doc/VI_PED_ped.pdf"
                                       target="_blank"
                                       rel="noopener noreferrer">
                                        Педагогика
                                    </a>
                                </li>
                            </ul>

                            <p>Виды искусства:</p>
                            <ul>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/aspirant/doc/VI_ISK_fil.pdf"
                                       target="_blank"
                                       rel="noopener noreferrer">
                                        Философия
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/aspirant/doc/VI_ISK_in.pdf"
                                       target="_blank"
                                       rel="noopener noreferrer">
                                        Иностранный язык
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.art-gzhel.ru/abitur/aspirant/doc/VI_ISK_ist.pdf"
                                       target="_blank"
                                       rel="noopener noreferrer">
                                        История искусств
                                    </a>
                                </li>
                            </ul>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </p>
        </div>
    );
}

export default App3;